import {Position} from "../interfaces/interfaces";

import {svgIcons} from "@/constants/icons";

export const _CONST = {
  svgIcons,

  lsKey: '_NT_ADMIN_',

  wsReconnextMaxCount: 10,

  subscriptions: {
    AdminTasksUpdate: 'AdminTasksUpdate',
    LiquidityPricesUpdated: 'LiquidityPricesUpdated',
    LiquiditySettingsUpdated: 'LiquiditySettingsUpdated',
    VolumeSettingsUpdated: 'VolumeSettingsUpdated',
    SymbolSettingsUpdate: 'SymbolSettingsUpdate',
    LiquidityErrorsCountChanged: 'LiquidityErrorsCountChanged',
  },

  lsKeys: {
    lang: 'lang',
    user: 'user',
    login: 'login',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    refreshCsrfToken: 'refreshCsrfToken',
    withoutAuth: 'withoutAuth',
    prevRoute: 'prevRoute',
    userEcho: 'userEcho'
  },

  event: {
    refresh: 'refresh',
    logout: 'logout',
    welcome: 'welcome',
  },

  orderBookItemType: {
    bid: 'Bid',
    ask: 'Ask',
  },

  orderSide: {
    buy: 'Buy',
    sell: 'Sell',
  },

  bitflowCurrencies: {
    bch: 'bch',
    btc: 'btc',
    doge: 'doge',
    eth: 'eth',
    ltc: 'ltc',
    yeenus: 'yeenus',
    zeenus: 'zeenus',
  },

  timeZoneType: {
    default: 'default',
    server: 'server',
    local: 'local',
  },

  currencyList: {
    BTC: {
      symbol: '₿',
      isRight: true,
      precision: 5,
    },
    ETH: {
      symbol: 'Ξ',
      isRight: true,
      precision: 5,
    },
    LTC: {
      symbol: 'Ł',
      isRight: true,
      precision: 5,
    },
    EUR: {
      symbol: '€',
      isRight: true,
      precision: 5,
    },
    USD: {
      symbol: '$',
      isRight: false,
      precision: 5,
    },
    TST1: {
      symbol: 'T',
      isRight: false,
      precision: 5,
    },
    TST2: {
      symbol: 'T',
      isRight: false,
      precision: 5,
    },
  },

  currencySymbolPosition: {
    BTC: Position.Right,
    ETH: Position.Right,
    LTC: Position.Right,
    EUR: Position.Right,
    USD: Position.Left,
    TST1: Position.Left,
    TST2: Position.Left,
  },

  currencySymbol: {
    BTC: '₿',
    ETH: 'Ξ',
    LTC: 'Ł',
    EUR: '€',
    USD: '$',
    TST1: '$',
    TST2: '$',
  },

  gatewayLabelRub: {
    QiwiWallet: "Qiwi wallet",
    NetexCode: "Fortnex Code",
    BankCards: "Bank card",
    CashbackBonus: "Cashback",
    FirekassaTinkoff: "Tinkoff FK",
    FirekassaSber: "Sberbank FK",
    RuTransportTinkoff: "Tinkoff RT",
    RuTransportSber: "",
    Cash: "Cash"
  },

  gatewayLabelName: {
    Bep20: "BSC",
    Erc20: "ERC20",
    Trc20: "TRC20",
  },

  gatewayLabelDesc: {
    Bep20: "BNB Smart Chain BEP20",
    Erc20: "Ethereum",
    Trc20: "Tron",
  },

  paginationOptions: [5, 10, 20, 50, 100, 1000],

  defaultPrecision: 8,

  precisionType: {
    symbol: 'symbol',
    base: 'base',
    quoted: 'quoted',
    step: 'step',
    currency: 'currency',
    precision: 'precision',
  },

  optionsYesNo: [
    {
      label: 'Да',
      value: true,
    },
    {
      label: 'Нет',
      value: false,
    }
  ],

  optionsYesNo10: [
    {
      label: 'Да',
      value: 1,
    },
    {
      label: 'Нет',
      value: 2,
    }
  ],

  USD: {
    currencyName: 'USD',
    isRight: false,
    precision: 2
  },

  adminTaskType: {
    DisabledSymbol: 'DisabledSymbol',
    PaymentCardsVerification: 'PaymentCardsVerification',
    UserVerification: 'UserVerification',
    SecurityQuests: 'SecurityQuests',
    StuckWithdrawals: 'StuckWithdrawals',
    BalanceDeviation: 'BalanceDeviation',
    RealBalanceState: 'RealBalanceState',
    RutransportBalanceState: 'RutransportBalanceState',
    NegativeBalances: 'NegativeBalances',
    FailedClearings: 'FailedClearings',
    ReserveBalanceState: 'ReserveBalanceState',
  },

  permissions: {
    Accounts: {
      Clients: {
        self: 'Accounts.Clients',
        AssetsAndLedgers: 'Accounts.Clients.AssetsAndLedgers',
        Block: 'Accounts.Clients.Block',
        BlockEdit: 'Accounts.Clients.BlockEdit',
        Fingerprints: 'Accounts.Clients.Fingerprints',
        Journal: 'Accounts.Clients.Journal',
        LimitsAndFees: 'Accounts.Clients.LimitsAndFees',
        LimitsAndFeesEdit: 'Accounts.Clients.LimitsAndFeesEdit',
        PersonalInfo: 'Accounts.Clients.PersonalInfo',
        SecurityQuests: 'Accounts.Clients.SecurityQuests',
        Postings: 'Accounts.Clients.Postings',
        ManualPostings: 'Accounts.Clients.ManualPostings',
        ResetPassword: 'Accounts.Clients.ResetPassword',
        PrivateApi: 'Accounts.Clients.PrivateApi',
        Pnl: 'Accounts.Clients.Pnl',
        AddressBook: 'Accounts.Clients.AddressBook',
      },
      Admins: {
        self: 'Accounts.Admins',
        ResetPassword: 'Accounts.Admins.ResetPassword'
      },
      SecurityQuests: {
        self: 'Accounts.SecurityQuests',
        Edit: 'Accounts.SecurityQuests.Edit'
      }
    },
    Fills: 'Fills',
    Funding:
      {
        self: 'Funding',
        CommunicationLogs: 'Funding.CommunicationLogs',
        ClearingHistory: 'Funding.ClearingHistory',
        ClearingManualProcessing: 'Funding.ClearingManualProcessing',
        ManualDeposit: 'Funding.ManualDeposit',
        WithdrawalConfirmation: 'Funding.WithdrawalConfirmation',
        BrokerDeposit: "Funding.BrokerDeposit",
        FundingEdit: "Funding.FundingEdit",
        CashEdit : "Funding.CashEdit"
      },
    Ledger: 'Ledger',
    Orders: {
      self: 'Orders',
      Cancel: 'Orders.Cancel',
      ForceCancelOrder: 'Orders.ForceCancel'
    },
    MatcherOrders: 'MatcherOrders',
    Position: 'Position',
    Settings: {
      self: 'Settings',
      SystemConfig: 'Settings.SystemConfig',
      AssetProcessing: 'Settings.AssetProcessing',
      AssetProcessingEdit: 'Settings.AssetProcessingEdit',
      CurrenciesAndSymbolsEdit: 'Settings.CurrenciesAndSymbolsEdit',
      Fees: 'Settings.Fees',
      FeesEdit: 'Settings.FeesEdit',
      Limits: 'Settings.Limits',
      LimitsEdit: 'Settings.LimitsEdit',
      Liquidity: 'Settings.Liquidity',
      Policies: 'Settings.Policies',
      PrivateApi: 'Settings.PrivateApi',
      PrivateApiEdit: 'Settings.PrivateApiEdit',
    },
    HtmlPages: {
      self: 'HtmlPages',
      Edit: "HtmlPages.Edit",
    },
    ManagmentAccounting: {
      self: 'ManagmentAccounting',
      ManualPosting: 'ManagmentAccounting.ManualPosting'
    },
    Verification: {
      self: 'Verification',
      Cards: 'Verification.Cards',
      PersonalInfo: 'Verification.PersonalInfo',
    },
    Withdrawals: {
      self: 'Withdrawals',
      Cancel: 'Withdrawals.Cancel',
      Complete: 'Withdrawals.Complete',
      Reset: 'Withdrawals.Reset',
    }
  },

  symbolMarketType: [
    {label: 'Regular', value: 'Regular'}
  ],

  userTradingRole: [
    {label: 'Regular', value: 'Regular'},
    {label: 'RuTransport', value: 'RuTransport'},
    {label: 'FundingShop', value: 'FundingShop'},
    {label: 'Trader', value: 'Trader'},
    {label: 'Merchant', value: 'Merchant'},
    {label: 'ReferralsHost', value: 'ReferralsHost'},
    {label: 'PaymentAgent', value: 'PaymentAgent'},
    {label: 'USDT PaymentAgent', value: 'PaymentAgentUsdt'},
    {label: 'External', value: 'External'},
    {label: 'FiatMerchant', value: 'FiatMerchant'},
  ],

  amlScoringCategories: {
    Ransom: 'Ransom',
    DarkService: 'DarkService',
    Other: 'Other',
    StolenCoins: 'StolenCoins',
    InfrastructureAsAService: 'InfrastructureAsAService',
    ExchangeMlriskVeryhigh: 'ExchangeMlriskVeryhigh',
    Miner: 'Miner',
    TokenSmartContract: 'TokenSmartContract',
    ExchangeMlriskLow: 'ExchangeMlriskLow',
    IllicitActorOrg: 'IllicitActorOrg',
    ExchangeFraudulent: 'ExchangeFraudulent',
    P2pExchangeMlriskLow: 'P2pExchangeMlriskLow',
    P2pExchange: 'P2pExchange',
    DarkMarket: 'DarkMarket',
    IllegalService: 'IllegalService',
    Payment: 'Payment',
    Atm: 'Atm',
    ExchangeMlriskHigh: 'ExchangeMlriskHigh',
    LendingContract: 'LendingContract',
    RiskyExchange: 'RiskyExchange',
    ChildExploitation: 'ChildExploitation',
    Marketplace: 'Marketplace',
    ExchangeMlriskModerate: 'ExchangeMlriskModerate',
    P2pExchangeMlriskHigh: 'P2pExchangeMlriskHigh',
    DecentralizedExchangeContract: 'DecentralizedExchangeContract',
    FraudShop: 'FraudShop',
    EnforcementAction: 'EnforcementAction',
    ProtocolPrivacy: 'ProtocolPrivacy',
    UnnamedService: 'UnnamedService',
    Mixer: 'Mixer',
    LiquidityPools: 'LiquidityPools',
    TerrorismFinancing: 'TerrorismFinancing',
    SmartContract: 'SmartContract',
    Sanctions: 'Sanctions',
    HighRiskJurisdiction: 'HighRiskJurisdiction',
    MerchantServices: 'MerchantServices',
    SpecialMeasures: 'SpecialMeasures',
    OnlinePharmacy: 'OnlinePharmacy',
    Bridge: 'Bridge',
    Malware: 'Malware',
    NftPlatformCollection: 'NftPlatformCollection',
    Ico: 'Ico',
    Unknown: 'Unknown',
    Scam: 'Scam',
    SeizedAssets: 'SeizedAssets',
    Wallet: 'Wallet',
    Exchange: 'Exchange',
    Gambling: 'Gambling'
  },

  shardScoringCategories: {
    ArmsTrafficking: 'ArmsTrafficking',
    Blackmail: 'Blackmail',
    Exchange: 'Exchange',
    Gambling: 'Gambling',
    ChildAbuse: 'ChildAbuse',
    Malware: 'Malware',
    Marketplace: 'Marketplace',
    MiningReward: 'MiningReward',
    MixingPattern: 'MixingPattern',
    Ransomware: 'Ransomware',
    SanctionList: 'SanctionList',
    Scam: 'Scam',
    P2pExchange: 'P2pExchange',
    DarkMarket: 'DarkMarket',
    Darkservice: 'Darkservice',
    Drugs: 'Drugs',
    EnforcementActions: 'EnforcementActions',
    Fpwmd: 'Fpwmd',
    Hack: 'Hack',
    HumanTrafficking: 'HumanTrafficking',
    IllegalService: 'IllegalService',
    Phishing: 'Phishing',
    Ponzi: 'Ponzi',
    SeizedFund: 'SeizedFund',
    StolenToken: 'StolenToken',
    Terrorism: 'Terrorism',
    UaSupport: 'UaSupport',
    AdultContent: 'AdultContent',
    Dice: 'Dice',
    Extremism: 'Extremism',
    SanctionedJurisdiction: 'SanctionedJurisdiction',
    UntrustedService: 'UntrustedService',
    AnonymizingActivity: 'AnonymizingActivity',
    InfrastructureService: 'InfrastructureService',
    UntrustedVasp: 'UntrustedVasp',
    Charity: 'Charity',
    Crowdfunding: 'Crowdfunding',
    Dex: 'Dex',
    Donation: 'Donation',
    Fund: 'Fund',
    Game: 'Game',
    Nft: 'Nft',
    CryptoAtm: 'CryptoAtm',
    CivilLawsuit: 'CivilLawsuit',
    ExchangeMr: 'ExchangeMr',
    CloudMining: 'CloudMining',
    ColdWallet: 'ColdWallet',
    Investment: 'Investment',
    Media: 'Media',
    Otc: 'Otc',
    Pep: 'Pep',
    Political: 'Political',
    HotWallet: 'HotWallet',
    Lending: 'Lending',
    PaymentProvider: 'PaymentProvider',
    Cultural: 'Cultural',
    Custody: 'Custody',
    Education: 'Education',
    Faucet: 'Faucet',
    MiningPool: 'MiningPool',
    Government: 'Government',
    Individual: 'Individual',
    SmartContract: 'SmartContract',
    Staking: 'Staking',
    DexDeFi: 'DexDeFi',
    Info: 'Info',
    Unknown: 'Unknown',
  },

  scorechainScoringCategories: {
    UnspentOutput: 'UnspentOutput',
    MiningReward: 'MiningReward',
    Donations: 'Donations',
    MiningPool: 'MiningPool',
    PeelingChainOfUnknownOrigin: 'PeelingChainOfUnknownOrigin',
    CloudMining: 'CloudMining',
    Token: 'Token',
    Service: 'Service',
    DecentralizedService: 'DecentralizedService',
    Airdrop: 'Airdrop',
    LargeUnnamedEntity: 'LargeUnnamedEntity',
    IgnoredSmallAmounts: 'IgnoredSmallAmounts',
    MaximumExplorationDepth: 'MaximumExplorationDepth',
    LargeTransaction: 'LargeTransaction',
    Ico: 'Ico',
    Exchange: 'Exchange',
    Gambling: 'Gambling',
    Wallet: 'Wallet',
    Dex: 'Dex',
    ClosedExchange: 'ClosedExchange',
    Suspicious: 'Suspicious',
    MixingService: 'MixingService',
    MixingPattern: 'MixingPattern',
    Scam: 'Scam',
    Hack: 'Hack',
    Phishing: 'Phishing',
    DarkWeb: 'DarkWeb',
    OfacSanctionList: 'OfacSanctionList',
    ReportedByBitcoinAbuseCom: 'ReportedByBitcoinAbuseCom',
    Terrorism: 'Terrorism',
    CommunityReportedScam: 'CommunityReportedScam',
    ChildAbuse: 'ChildAbuse',
    OngoingLegalAction: 'OngoingLegalAction',
    PaymentChannel: 'PaymentChannel',
    BlockReward: 'BlockReward',
    SecondaryCoinCreation: 'SecondaryCoinCreation',
    SecondaryCoinRemoval: 'SecondaryCoinRemoval',
    CrossChainBridgeProtocol: 'CrossChainBridgeProtocol',
    SanctionList: 'SanctionList',
    NftMarketplace: 'NftMarketplace',
    Ransomware: 'Ransomware',
    Bank: 'Bank',
    SeizedAssets: 'SeizedAssets',
    StakingPool: 'StakingPool',
    InvestmentManagementFirm: 'InvestmentManagementFirm'
  }
}
